module.exports = __webpack_public_path__ + "img/thumbnail_Nyala_j_albino.387000ee.png";